import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import IconCard from 'organisms/Cards/IconCard';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { CustomCardProps } from 'components/CustomCard/config';

import { hasArrayValues } from 'utils/array/arrays';

const CustomCard: FC<CustomCardProps> = props => {
  const {
    rest: { cards },
  } = splitSectionProps(props);

  return (
    <Section darkMode bare>
      <ScrollFadeSection delay={0.3}>
        <div className="-mx-4 flex flex-wrap justify-start gap-y-8">
          {hasArrayValues(cards) &&
            cards.map(card => (
              <div
                key={card.id}
                className={twJoin(
                  'w-full shrink-0 grow-0 px-4 sm:w-1/2 sm:basis-1/2',
                  cards.length % 3 === 0 ? 'lg:w-1/3 lg:basis-1/3' : 'lg:w-1/4 lg:basis-1/4',
                )}
              >
                <IconCard {...card} darkCard />
              </div>
            ))}
        </div>
      </ScrollFadeSection>
    </Section>
  );
};

export default CustomCard;
